import { render, staticRenderFns } from "./ShueiJinJiouFooter.vue?vue&type=template&id=3c067872"
import script from "./ShueiJinJiouFooter.vue?vue&type=script&lang=js"
export * from "./ShueiJinJiouFooter.vue?vue&type=script&lang=js"
import style0 from "./ShueiJinJiouFooter.vue?vue&type=style&index=0&id=3c067872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports